
import { Vue } from "vue-class-component";

export default class SkeletonModalShipmentV3 extends Vue {}
